import http from '@/util/request'

/**
 * 切换客服状态 https://qa-boss.amh-group.com/yapi/#/project/2289/interface/api/148120
 * @param params
 * @param params.targetStatus {Number} 设置状态 1-空闲 2-忙碌 3-离线 4-会话中
 * @returns {*}
 */
export const changeStatus = params =>
  http({
    url: 'crm-online-service-app/onlineCustomerService/serviceUser/changeStatus',
    method: 'post',
    data: params
  })
